import { useDashboardFeatureFlags } from '@components';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { useCreatorIntegrationsQuery } from '@modules/Dashboard/pages/Apps';
import { routing } from '@utils/routing';
import twitchPromotion from '@modules/Dashboard/Home/modules/recommendations/assets/twitch-promotion.png';
import { useRecommendationsDismiss } from '../useRecommendationsDismiss';
export const useTwitchPromotionRecommendation = () => {
    const { currentShop } = useCurrentShop();
    const { creatorIntegrationsQuery } = useCreatorIntegrationsQuery();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const hasTwitchPlatform = 
    // @ts-ignore
    currentShop?.metafields?.onboarding?.['oauth-flow'] === true &&
        // @ts-ignore
        currentShop?.metafields?.onboarding?.['creator-platform'] === 'twitch';
    const hasTwitchSocial = !!currentShop?.social.twitch;
    const shouldShowTwitchRecommendation = hasTwitchPlatform ||
        hasTwitchSocial ||
        creatorIntegrationsQuery.data?.twitch.status === 'CONNECTED';
    const getDescription = () => {
        if (dashboardFeatureFlags.memberships.enabled) {
            return 'Offer your Twitch subscribers deals on products and/or memberships';
        }
        return 'Offer your Twitch subscribers exclusive deals';
    };
    return {
        twitchPromotionRecommendation: {
            enabled: shouldShowTwitchRecommendation && recommendationsDismiss.twitchPromotion.visible,
            suggestionProps: {
                type: 'props',
                props: {
                    title: 'Offer discounts for Twitch subs',
                    description: getDescription(),
                    imageUrl: twitchPromotion,
                    analytics: 'twitchPromotion',
                    buttonLabel: 'Set up discounts for Twitch subs',
                    buttonTo: routing.apps.twitchMembershipsDiscounts,
                    onDismiss: createOnDismiss(recommendationsDismiss.twitchPromotion.dismiss),
                },
            },
        },
    };
};
